import { action, makeAutoObservable, observable } from "mobx";
import { analytics } from "../services/analytics";

export default class GlobalPopupStore {
  isVisible: boolean = false;
  message: string = "";
  description: string = "";
  onContinue?: () => void;

  constructor() {
    makeAutoObservable(this, {
      isVisible: observable,
      message: observable,
      description: observable,
      onContinue: observable,
      show: action,
      hide: action,
    });
  }

  show(message: string, description: string = "", onContinue?: () => void) {
    // Central popup analytics — every blocking message the store shows,
    // with zero per-call-site wiring (parity with dashboard alert_shown).
    analytics.track("alert_shown", { title: message.slice(0, 80) });
    this.message = message;
    this.description = description;
    this.onContinue = onContinue
      ? () => {
          this.hide();
          onContinue();
        }
      : undefined;
    this.isVisible = true;
  }

  hide() {
    this.isVisible = false;
    this.onContinue = undefined;
    this.message = "";
    this.description = "";
  }
}